import React from "react";
import { Route, Routes } from "react-router-dom";
import Validations from "../views/Validations/Validations";

const Router = () => {
  return (
    <Routes>
      <Route path="/:orgId" element={<Validations />} />
    </Routes>
  );
};

export default Router;
